import React from 'react';
import { array, object, string, func, bool } from 'prop-types';
import classnames from 'classnames';
import { ModalStyled, Box, Stack } from '@nike/nike-design-system-components';

import ProductImage from '~COMPONENTS/aurora/ProductImage';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { Table } from '../../components';
import PdpPrice from './PdpPrice';

import { mapFutureAvailability } from '../../util/mapAvailability';

import getFutureAvailabilitiesColumns from './futureAvailabilitiesColumns';

const PdpFutureAvailabilities = ({
  futureAvailabilityData,
  productName,
  selectedProductPrices,
  productCode,
  colorName,
  sizes,
  locale,
  isOpen,
  closeModal
}) => {
  const { futureSizeData, allUniqueDates } = mapFutureAvailability(futureAvailabilityData, productCode, sizes);
  const columns = getFutureAvailabilitiesColumns(allUniqueDates, locale);
  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={closeModal}
      title=''
      modalRootCompProps={{ style: { maxWidth: '1000px' } }}
      modalMainCompProps={{ style: { minHeight: '120px' } }}
      modalHeaderCompProps={{ style: { paddingBottom: '16px' } }}
      slots={{
        HeaderTitleSlot: (
          <Box style={{ fontSize: '14px' }}>
            <Box style={{ padding: 0, display: 'flex' }}>
              <Box width='50px' height='50px'>
                <ProductImage productCode={productCode} alt={productCode} width={50} height={50} />
              </Box>
              <Box paddingInlineStart='10px'>
                <Stack>
                  <span>{productName}</span>
                  <PdpPrice selectedProductPrices={selectedProductPrices} />
                </Stack>
              </Box>
            </Box>
            <Stack style={{ fontWeight: 'normal' }}>
              <ul style={{ listStyle: 'disc', marginLeft: '20px' }}>
                <li>
                  <TranslatedCopy id='global.product.style' />
                  {': '}
                  {productCode}
                </li>
                <li>
                  <TranslatedCopy id='global.color' />
                  {': '}
                  {colorName}
                </li>
              </ul>
            </Stack>
          </Box>
        ),
        FooterSlot: (
          <>
            <Table
              overrideClass={classnames('pdp__future_availabilities_table')}
              data={futureSizeData}
              columns={columns}
            />
            <Box paddingBlockStart='20px'>
              <TranslatedCopy id='pdp.futureAvailabilities.modal.note' />
            </Box>
          </>
        )
      }}
    />
  );
};

PdpFutureAvailabilities.propTypes = {
  futureAvailabilityData: object.isRequired,
  productName: string,
  selectedProductPrices: array,
  productCode: string,
  colorName: string,
  sizes: array,
  locale: string,
  isOpen: bool.isRequired,
  closeModal: func.isRequired
};

PdpFutureAvailabilities.defaultProps = {
  productName: '',
  selectedProductPrices: [],
  productCode: '',
  colorName: '',
  sizes: [],
  locale: ''
};

export default PdpFutureAvailabilities;
